// src/components/quiz/QuestionImageMC.jsx
import React from 'react';

export default function QuestionImageMC({ question, options, selected, feedback, onAnswer }) {
  return (
    <>
      <div className="bg-white p-6 rounded-[2rem] border-2 border-slate-100 shadow-sm text-center mb-6">
        <span className="text-[10px] font-black uppercase tracking-widest text-indigo-400 block mb-2">
          SELECCIONA LA IMAGEN CORRECTA
        </span>
        <h3 className="text-xl font-black text-slate-700">{question.q}</h3>
      </div>

      <div className="grid grid-cols-2 gap-4">
        {options.map((opt) => {
          const optKey = opt?.id || opt;
          const optValue = opt?.img || opt;

          return (
            <button
              key={optKey}
              disabled={!!feedback}
              onClick={() => onAnswer(optKey)}
              className={`p-4 rounded-3xl border-4 transition-all relative overflow-hidden aspect-square flex items-center justify-center bg-white shadow-sm hover:shadow-md active:scale-95 ${
                selected === optKey
                  ? (feedback === 'correct' 
                      ? 'border-green-500 bg-green-50 scale-95' 
                      : 'border-red-500 bg-red-50 scale-95')
                  : 'border-slate-200 hover:border-indigo-300 hover:-translate-y-1'
              }`}
            >
              <img 
                src={optValue} 
                alt="option" 
                className="w-full h-full object-contain pointer-events-none" 
              />
            </button>
          );
        })}
      </div>
    </>
  );
}